import React, { useState, useEffect } from 'react';
import { Icon } from 'tea-component';
import CardSlot from '@/pages/intelligence/components/CardSlot';
import * as echarts from 'echarts';
import { formatNum, formatPercentNum } from '@/pages/intelligence/utils/commonUtils';
import {
  sortTime,
  fixLineData,
  formatEnTimeByStr,
} from '@/pages/intelligence/pages/MarketProfile/_util';
import { drawLineChart } from '../../hooks/_echartsUtil';
import { useIntl } from 'umi';
import NoData from '@/pages/intelligence/components/NoData';
import './topGenre.less';
import ChartBubble from '@/pages/intelligence/components/ChartBubble';
import moment from 'moment';
import { mapColor, mapColorMap, subTreeColor, mapColors } from './_config';
import { getSafeGenreSource, getGenreNameI18n } from '@intelligence/v3/utils/genre';

const TOP_GENRE_SOURCES = ['iegg', 'annie', 'sensortower', 'appmagic'] as const;

export default function TopGenre(props: any) {
  const { data, genreOptionsMap, genreSource } = props;
  const [chartType, setChartType] = useState('chart-treemap');
  const [subType, setSubType] = useState('');
  const [treeMapData, setTreeMapData] = useState([]);
  const [genreLineData, setGenreLineData] = useState([]);
  const [genreLineDataSelected, setGenreLineDataSelected] = useState({});
  const [genreLineAxiasData, setGenreLineAxiasData] = useState([]);
  const [time, setTime] = useState('');
  const [aaa, setAaa] = useState([]);
  const [treeMapColor, setTreeMapColor] = useState({});
  const { formatMessage, locale } = useIntl();
  const [childColors, setChildColors] = useState<string[]>([]);

  const formatGenreName = (genreName: string) => {
    if (!genreName) {
      return '';
    }

    const normalizedGenreSource = getSafeGenreSource(genreSource, TOP_GENRE_SOURCES, '');

    return getGenreNameI18n({
      locale,
      genreOptionsMap,
      genreSource: normalizedGenreSource,
      genreValue: genreName,
    } as any);
  };

  const resizeHandler = () => {
    const treeDom = document.getElementById('topGenreChart');
    if (treeDom) {
      const treeChart = echarts.init(treeDom);
      try {
        treeChart.resize();
      } catch (e) {}
    }
    const lineDom = document.getElementById('topGenreChartLine');
    if (lineDom) {
      const lineChart = echarts.init(lineDom);
      try {
        lineChart.resize();
      } catch (e) {}
    }
  };

  const getTreeItemColor = (name: any, index: number) => {
    const colorItem = treeMapColor as any;
    colorItem[name] = mapColors[index];
    setTreeMapColor(colorItem);
    return mapColors[index];
  };

  const getSubColor = (value: any, mainColor) => {
    let color = '';
    subTreeColor.map((item, index) => {
      if (value >= item.min && value < item.max) {
        // color = item['color'];
        color = mapColorMap?.[mainColor]?.[index];
      }
    });
    return color;
  };

  useEffect(() => {
    window.addEventListener('resize', resizeHandler);
    if (data) {
      const dealData = [] as any;
      const oneMenuTemp = [] as any;
      const mainLabel = {
        position: 'insideTopLeft',
        formatter(params: any) {
          let precent = 0;
          if (params.treeAncestors.length == 3) {
            precent = formatPercentNum(params.value / params.treeAncestors[1].value);
          } else {
            precent = formatPercentNum(params.value / params.treeAncestors[0].value);
          }
          const html =
            `{name|${formatGenreName(params.name)}}\n` +
            `{num|$${formatNum(params.value, true)}}\n` +
            `{precent|${precent}}`;
          return html;
        },
        rich: {
          name: {
            fontSize: 12,
            color: '#fff',
            padding: [10, 0, 0, 10],
          },
          num: {
            fontSize: 16,
            color: '#fff',
            padding: [9, 0, 9, 10],
          },
          precent: {
            fontSize: 16,
            color: '#fff',
            padding: [0, 0, 0, 10],
          },
        },
      };

      const genreTreeData = data.market_top_genre;
      let showTime = '';
      if (genreTreeData) {
        let date = [] as any;
        if (data.start_date && data.end_date) {
          if (data.init == 1) {
            date = [data.end_date, data.end_date];
          } else {
            date = [data.start_date, data.end_date];
          }
          showTime = moment(data.start_date).format('MMM, YYYY');
          setTime(showTime);
        }
        const tmpData = genreTreeData.sort((a: any, b: any) => b.name_rev - a.name_rev);
        tmpData.map((item: any, index: number) => {
          if (item.name_rev != 0 || item.children) {
            oneMenuTemp.push(item.name);
            const tempObj = {
              name: item.name,
              value: item.name_rev,
              label: mainLabel,
              itemStyle: {
                color: getTreeItemColor(item.name, index),
              },
              time: date,
            } as any;
            const childrenItem = item.children;
            if (childrenItem) {
              const children = [] as any;
              childrenItem.map((item_children: any) => {
                if (item_children.Value != 0) {
                  const obj = {
                    name: item_children.Name,
                    value: item_children.Value,
                    itemStyle: {
                      color: getSubColor(item_children.Value, getTreeItemColor(item.name, index)),
                    },
                    time: date,
                    silent: true,
                    label: mainLabel,
                  };
                  children.push(obj);
                }
              });
              tempObj.children = children;
            }
            dealData.push(tempObj);
          }
        });
      }
      const lineData = data.top_genre_rev_daily;
      const xAxis = [] as any;
      const genreLineDataTemp = [] as any;
      const selectedLine = {} as any;
      if (lineData) {
        lineData.sort(sortTime('date'));

        const tmpData = {} as any;
        lineData.map((item: any, index: number) => {
          const revenueData = item.name_rev;
          if (revenueData) {
            revenueData.map((obj: any) => {
              let values = tmpData[obj.name] || [];
              values = fixLineData(values, index);
              values.push(obj.rev);
              tmpData[obj.name] = values;
              selectedLine[obj.name] = false;
            });
            xAxis.push(moment(item.date).format('YYYY-MM'));
          }
        });
        Object.keys(selectedLine).map((key, index) => {
          if (index < 6) {
            selectedLine[key] = true;
          } else {
            selectedLine[key] = false;
          }
        });
        setGenreLineDataSelected(selectedLine);
        Object.keys(tmpData).map((t) => {
          const obj = {
            name: t,
            type: 'line',
            data: tmpData[t],
          };
          genreLineDataTemp.push(obj);
        });
        setGenreLineData(genreLineDataTemp);
        setGenreLineAxiasData(xAxis);
      }
      const tmpDealData = [] as any;
      dealData.map((item: any) => {
        if (item.value != 0 || item.children.length > 0) {
          tmpDealData.push(item);
        }
      });
      setTreeMapData(tmpDealData);
      setTimeout(() => {
        if (chartType === 'chart-treemap') {
          mpTreeMapCharts('topGenreChart', tmpDealData, showTime);
        }
        if (chartType === 'discount-chart') {
          drawLineChart(
            'topGenreChartLine',
            genreLineDataTemp,
            xAxis,
            selectedLine,
            mapColor,
            formatGenreName,
          );
        }
      }, 500);
    }
    return () => {
      window.removeEventListener('resize', resizeHandler);
    };
  }, [data, locale, genreOptionsMap, genreSource]);

  const mpTreeMapCharts = (containId: any, data: any, showTime: string) => {
    const chartDom = document.getElementById(containId);
    if (chartDom) {
      const myChart = echarts.init(chartDom);
      const barFormatterTooltip = (params: any) => {
        let precent;
        if (params.treeAncestors.length == 3) {
          precent = formatPercentNum(params.value / params.treeAncestors[1].value);
        } else {
          precent = formatPercentNum(params.value / params.treeAncestors[0].value);
        }
        return ChartBubble({
          data: params,
          secondTitleLeft: showTime,
          secondTitleRight: 'Revenue',
          leftContent: formatGenreName(params.name),
          // titleNow,
          topChartsType: 'marketProfile-mapTree',
          imageType: 'mobile',
          chartType: '',
          dateType: 'month',
          rightContent: `${formatNum(params.value, true)} (${precent})`,
          ifNoBarImg: true,
        });
      };
      const option = {
        title: {
          show: false,
        },
        tooltip: {
          trigger: 'item',
          padding: 0,
          borderWidth: 0,
          formatter: barFormatterTooltip,
          backgroundColor: 'rgba(0, 0, 0, 0)',
        },
        legend: {
          show: false,
        },
        series: [
          {
            name: 'option',
            type: 'treemap',
            visibleMin: 300,
            left: 0,
            top: 0,
            width: '100%',
            height: '100%',
            drillDownIcon: '',
            roam: false,
            breadcrumb: { show: false },
            data,
            leafDepth: 1,
            levels: [
              {
                itemStyle: {
                  borderColor: 'rgba(255,255,255,0.4)',
                  gapWidth: 2,
                },
              },
              {
                colorSaturation: [0.3, 0.6],
                itemStyle: {
                  borderColor: 'rgba(255,255,255,0.4)',
                  gapWidth: 2,
                },
              },
            ],
          },
        ],
      };
      option && myChart.setOption(option, true);
      myChart.resize();
      myChart.on('click', function (params) {
        // @ts-ignore
        if (params?.data?.children?.length > 0) {
          aaa.length = 0;
          aaa.push(formatGenreName(params.name));
          setAaa([...aaa]);
          const itemColor = params?.data?.itemStyle?.color;
          const colorList = mapColorMap?.[itemColor];
          setChildColors(colorList);
          setSubType(formatGenreName(params.name));
        } else {
          // let name = aaa[0] || params.name;
          // fun && fun(name);
        }
      });
    }
  };

  const treemapBack = () => {
    const chartDom = document.getElementById('topGenreChart');
    if (chartDom) {
      const myChart = echarts.getInstanceByDom(chartDom);
      const option = myChart.getOption() as any;
      option.series[0].leafDepth = 1;
      myChart.setOption(option);
      myChart.resize();
      aaa.length = 0;
      setAaa([]);
      setSubType('');
    }
  };

  const chartTypeChange = (icon: string) => {
    setChartType(icon);
    if (icon === 'chart-treemap') {
      setTimeout(() => {
        mpTreeMapCharts('topGenreChart', treeMapData, time);
      }, 500);
    } else {
      setSubType('');
      setTimeout(() => {
        drawLineChart(
          'topGenreChartLine',
          genreLineData,
          genreLineAxiasData,
          genreLineDataSelected,
          mapColor,
          formatGenreName,
        );
      }, 500);
    }
  };

  return (
    <CardSlot
      className="mpDetailTopGenre tabdetails-top"
      title={
        <div className="tabdetails-gamehead" style={{ marginBottom: 10 }}>
          <div className="tabdetails-gamehead-title">
            {formatMessage({ id: 'dbi_market_top_genre' })}
          </div>
          <div className="tabdetails-gamehead-text">{time}</div>
        </div>
      }
      iconList={[
        {
          value: 'chart-treemap',
          context: formatMessage({ id: 'dbi_tree_map' }),
          contextEn: 'Rectangular Tree Diagram',
          contextCn: '矩形树图',
          icon: 'chart-treemap',
        },
        {
          value: 'discount-chart',
          context: formatMessage({ id: 'dbi_line_chart' }),
          contextEn: 'Folding Line Diagram',
          contextCn: '折线图',
          icon: 'discount-chart',
        },
      ]}
      activeTab={chartType}
      getChange={chartTypeChange}
    >
      {subType == '' ? (
        <div className="topGenreSecondPart" style={{ height: '0px', padding: 0 }}></div>
      ) : (
        <div
          className="topGenreSecondPart"
          style={{ height: '36px', color: '#3B3D4B', cursor: 'pointer' }}
          onClick={() => {
            treemapBack();
          }}
        >
          <i
            className="tea-icon tea-icon-arrowdown"
            style={{
              transform: 'rotate(90deg) translateY(-3px) translateX(3px)',
              marginRight: 10,
            }}
            role="img"
            aria-label="arrowdown"
          ></i>
          {/* <Icon
            size="s"
            type="btnback"
            className="secondIcon"
            onClick={() => {
              treemapBack();
            }}
          /> */}
          <span>{`  ${subType}`}</span>
        </div>
      )}
      {chartType == 'chart-treemap' ? (
        <div style={{ height: 484 }} id="topGenreChart" className="topGenreChart"></div>
      ) : (
        <></>
      )}
      {chartType == 'chart-treemap' && treeMapData.length == 0 ? (
        <div className="noData">
          <NoData height="100%" title="No trends data under current selections." />
        </div>
      ) : (
        <></>
      )}

      {chartType == 'discount-chart' ? (
        <div
          style={{ height: 560 }}
          id="topGenreChartLine"
          className="topGenreChart topGenreChart2"
        ></div>
      ) : (
        <></>
      )}

      {chartType == 'discount-chart' && genreLineAxiasData.length == 0 ? (
        <div className="noData">
          <NoData height="100%" title="No trends data under current selections." />
        </div>
      ) : (
        <></>
      )}
      {chartType == 'chart-treemap' ? (
        <div className="mapLegend">
          {subType == ''
            ? Object.keys(treeMapColor).map((key, index) => {
                return (
                  <div className="colorItem" key={index}>
                    <div className="mapPoint" style={{ backgroundColor: treeMapColor[key] }}></div>
                    <div className="mapTitle">{formatGenreName(key)}</div>
                  </div>
                );
              })
            : subTreeColor.map((item, index) => {
                const color = childColors?.[index] ?? item.color;
                return (
                  <div className="colorItem" key={index}>
                    <div
                      className="mapPoint"
                      style={{ backgroundColor: color /* item['color']*/ }}
                    ></div>
                    <div className="mapTitle">
                      {`${formatNum(item.max)}~${formatNum(item.min)}`}
                    </div>
                  </div>
                );
              })}
        </div>
      ) : (
        <></>
      )}
    </CardSlot>
  );
}
